export default "__VITE_ASSET__BThb9uCc__"